import { render } from "./reportSG.vue?vue&type=template&id=44c201c9&scoped=true"
import script from "./reportSG.vue?vue&type=script&lang=js"
export * from "./reportSG.vue?vue&type=script&lang=js"

import "./reportSG.vue?vue&type=style&index=0&id=44c201c9&scoped=scoped&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c201c9"]])

export default __exports__